export default __webpack_public_path__ + "static/media/highway.8dd01e9a.png";